export default {
  row1 :[
  {
    column: "column1",

    rows: {
      row1: [
        {
          name: "exportProductJobWorkNotnno",
          label: "Notn.No",
          component: "text-field",
          width:"32%"

        },
        {
          name: "exportProductJobWorkBENumber",
          label: "BE Number",
          component: "text-field",
          width:"32%"

        },
        {
          name: "exportProductJobWorkDate",
          label: "Date",
          component: "dateselector",
          width:"32%"
        },
      ],
      row2: [
        {
          name: "exportProductJobWorkInvSrNo",
          label: "Inv SrNo",
          component: "text-field",
          dataType:"int",
        },
        {
          name: "exportProductJobWorkActualInvSrNo",
          label: "Actual Inv No",
          component: "text-field",
          dataType:"int",
        },
        {
          name:"exportProductJobWorkItemSrNo",
          label:"Item SrNo",
          component:"text-field",
          dataType:"int",
        }
      ],
      row3: [
        {
          name:"exportProductJobWorkImportedAt",
          label:"Imported At",
          component:"text-field",
         
        },
        {
          name:"exportProductJobWorkQuantity",
          label:"Quantity",
          component:"text-field",
          dataType:"int",
        },
        {
          name:"exportProductJobWorkUnit",
          label:"Unit",
          component:"text-field",
          endIconName:"LuSearch",
          type:"autocomplete",
          endpoint:"getQuantity"
        }
        
      ],
    },
  },
]
};
